<script>
export default {
    props: ['from'],
    name: "contactForm",
    data() {
        return {
            name: '',
            email: '',
            isLoading: false,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        submit() {
            if(this.isLoading){
                return false;
            }
            if(this.name.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.name.focus();
                this.$showToast({ text: '请输入姓名' }); //
                // this.$showToast({ text: 'Please enter name' }); //请输入姓名
                return false;
            }
            if(this.email.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.email.focus();
                this.$showToast({ text: '请输入邮箱' }); //请输入邮箱
                return false;
            }
            if(!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email))){
                this.$refs.email.focus();
                this.$showToast({ text: '邮箱格式有误' }); //邮箱格式有误
                return false;
            }
            this.isLoading = true;
            this.$showLoading();
            this.$store.dispatch('submitMessage', {
                type: this.from,
                name: this.name,
                email: this.email,
                phone: '',
                address: '',
                message: '',
                theme: '',
            }).then((result) => {
                this.isLoading = false;
                this.$hideLoading();
                if (result.code == 100) { 
                    this.$showToast({ text: '上传成功' });
                    this.name = '';
                    this.email = '';
                } else {
                    this.$showToast({ text: '上传失败' });
                }
            }).catch((err) => {
                this.isLoading = false;
                this.$showToast({ text: '上传失败' });
            });
        }
    },
};
</script>

<template>
    <div class="contact_form">
        <div class="layout_main wrapper">
            <div class="title">联系我们</div>
            <div class="desc">想要保持联系，但不是以需求的方式，请订阅我们的邮件，我们会不定期发送，告诉您我们最新的动态和签约信息。</div>
            <div class="form flex flex_column">
                <input type="text" ref="name" v-model="name" placeholder="姓名"/>
                <input type="text" ref="email" v-model="email" placeholder="邮箱"/>
                <p class="tip">＊ 请尽量填写不被屏蔽的邮箱以便您能正常收到，谢谢！</p>
                <div class="flex justify_end"><div class="btn layout_flex_center" @click="submit">提交</div></div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.contact_form{
    border-top: 1px solid #999;
}
.wrapper{
    padding: .5rem 0;
    .title{
        font-size: .25rem;
        margin-bottom: .2rem;
        @media only screen and (max-width: 750px) {
            font-size: .36rem;
            font-weight: bold;
        }
    }
    .desc{
        font-size: .22rem;
        width: 5.1rem;
        margin-bottom: .3rem;
        @media only screen and (max-width: 750px) {
            font-size: .26rem;
            width: auto;
        }
    }
    .form{
        width: 4.4rem;
        gap: .2rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
            gap: .3rem;
        }
        input,
        .btn{
            font-size: .2rem;
            height: .6rem;
            border: 1px solid #666;
            border-radius: .1rem;
            padding: 0 .3rem;
            &::placeholder{
                color: #999;
            }
            @media only screen and (max-width: 750px) {
                height: .84rem;
                font-size: .28rem;
            }
        }
        input{
            width: 100%;
        }
        .btn{
            height: .5rem;
            color: #666;
            cursor: pointer;
            @media only screen and (max-width: 750px) {
                width: 2.85rem;
                height: .7rem;
                font-size: .28rem;
                margin: 0 auto;
            }
        }
        .tip{
            font-size: .16rem;
            color: #666;
            text-align: justify;
            text-align-last: justify;
            @media only screen and (max-width: 750px) {
                font-size: .18rem;
                text-align: left;
                text-align-last: left;
                letter-spacing: .1em;
            }
        }
    }
}
</style>